import {EQUIPMENT_DOCUMENT_FILE_CONSTRAINTS} from '../constants/equipmentDocumentFileConstraints';

/**
 * Whether the file content starts with the PDF header. The MIME type a browser reports is guessed
 * from the extension, so a renamed file passes it; the header does not lie that easily.
 */
export const hasPdfSignature = (file: Blob) =>
  new Promise<boolean>((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result === EQUIPMENT_DOCUMENT_FILE_CONSTRAINTS.signature);
    reader.onerror = () => resolve(false);
    reader.readAsText(file.slice(0, EQUIPMENT_DOCUMENT_FILE_CONSTRAINTS.signature.length));
  });
